module.exports = __webpack_public_path__ + "img/7.7a9a0f69.png";